
import { PureFunctional, React } from '../../react';
import '../../types';

// Controls
import { Admin } from '../admin';
import ErrorControl from '../errorControl';
import { Flyover } from '../flyover';

/* tslint:disable */
declare interface WebpackRequire extends NodeRequire {
    ensure(a: any[], b: (r: any) => any): any;
}
declare var require: WebpackRequire;
declare global {
    interface Console {
        timeStamp(name: string): void;
    }
}
/* tslint:enable */

import cx from './style.less';

export default PureFunctional(`NoteApp`)(
    () => (
        <div className={cx('component')}>
            <Admin />
            <Flyover />
            <ErrorControl />
        </div>
    ));



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/app/index.tsx